import withLoadingInterval from './withLoadingInterval';

export default withLoadingInterval;
